import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";

import { ARTICLE_OR_ISSUE_TO_ARTICLE } from "./types";
import { useLoggedOutRetailerNodes } from "./useLoggedOutRetailerNodes";

export const useRetailerArticlesByNode = () => {
  const retailerNodes = useLoggedOutRetailerNodes();
  const articles = useArticles();
  const articlesByRetailerShipping = {
    [retailerNodes.L2.ImportFeesAndDuties]: [articles.International.BUY],
    [retailerNodes.L2.BuyingInternational]: [
      articles.ImportFeesAndDuties.USA,
      articles.ImportFeesAndDuties.Canada,
      articles.ImportFeesAndDuties.Europe,
    ],
    [retailerNodes.L2.Other]: [
      articles.FulfillingOrders.SHIPPING_WORK,
      articles.FulfillingOrders.SHIPPING_ADDRESS,
    ],
  };

  const articlesByNode: {
    [key: string]: ARTICLE_OR_ISSUE_TO_ARTICLE;
  } = {
    [retailerNodes.L1.Account]: [
      articles.GettingStarted.RESELLER_ID,
      articles.GettingStarted.BRICK_AND_MORTAR,
      articles.MyOrders.BUSINESS_PROFILE,
      articles.MyOrders.SYNC_SQUARE_POS,
    ],
    [retailerNodes.L1.HowFaireWork]: [
      articles.FAQ.RETAILER_WHAT_IS_FAIRE,
      articles.PaymentsAndInvoices.NET_60_TERMS,
      articles.MyOrders.FAIRE_PROTECTION,
      articles.GettingStarted.RESELLER_ID,
    ],
    [retailerNodes.L1.Invoices]: [
      articles.PaymentsAndInvoices.PAY_INVOICES,
      articles.PaymentsAndInvoices.NET_60_TERMS,
      articles.PaymentsAndInvoices.INVOICE_DUE,
    ],
    [retailerNodes.L1.Items]: [
      articles.MyOrders.REPORT_DAMAGED_MISSING,
      articles.MyOrders.ORDER_STATUS,
      articles.MyOrders.ORDER_QUESTIONS,
      articles.ReturnsAndRefunds.MAKE_A_RETURN,
    ],
    [retailerNodes.L1.Orders]: [
      articles.MyOrders.ORDER_STATUS,
      articles.MyOrders.ORDER_QUESTIONS,
    ],
    [retailerNodes.L1.Returns]: [
      articles.ReturnsAndRefunds.MAKE_A_RETURN,
      articles.FAQ.HOW_RETURNS_WORK,
      articles.ReturnsAndRefunds.CANT_RETURN,
    ],
    [retailerNodes.L1.GeneralShipping]: articlesByRetailerShipping,
    [retailerNodes.L1.Other]: [
      articles.MyOrders.FAIRE_PROTECTION,
      articles.MyOrders.BRAND_MINIMUMS,
      articles.FAQ.FAIRE_INSIDER_US,
      articles.FAQ.FAIRE_INSIDER_EU,
      articles.International.CANADIAN_RETAILERS,
    ],
  };
  return { retailerArticlesByNode: articlesByNode };
};
